
<template>
  <div class="post-suc">
    <img :src="banner" class="img" alt />
    <div class="f16" style="font-weight: bold; margin-top: 30px">
      操作成功，可添加客服微信尽快审核！
    </div>

    <div style="width: 80%; margin: 20px auto 10px">
      <van-button @click="go" size="large" type="primary">返回</van-button>
    </div>
  </div>
</template>

<script>
let me;
import { getData } from "../Interface/http.js";
export default {
  data() {
    return {
      banner: "",
    };
  },
  methods: {
    getBanner() {
      getData("/recommend-lists", {
        position: 6,
      }).then((res) => {
        me.banner = res.data[0].banner.thumb_url;
      });
    },
    go() {
      this.$router.go(-2);
    },
  },
  mounted() {
    me = this;
    this.getBanner();
  },
};
</script>

<style scoped>
.post-suc {
}
.img {
  width: 50%;
  margin-top: 20%;
}
</style>
